import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

const state = {
  supplierShippments: [],
  isModalVisible: false,
  details: []
}

const mutations = {
  SET_DETAILS (state, payload) {
    state.details = payload
  },
  DELETE_DETAIL (state, payload) {
    const idx = state.details.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.details, idx)
    }
  },
  SET_RECORDS (state, payload) {
    state.supplierShippments = payload
  },
  ADD_RECORD (state, payload) {
    state['supplierShippments'].unshift(payload)
  },
  UPDATE_RECORD (state, payload) {
    const idx = state['supplierShippments'].findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state['supplierShippments'], idx, payload)
    }
  },
  DELETE_RECORD (state, payload) {
    const idx = state.supplierShippments.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.supplierShippments, idx)
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  }
}

const actions = {
  async loadRecords ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`/purchase-orders/${payload.purchase_order_id}/supplier-shipments`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purcharse_orders_details.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addSupplierShipment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`/purchase-orders/${payload.purchase_order_id}/supplier-shipments`, payload.data)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.shippments', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_RECORD', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.shippments', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadPurchaseOrder ({ dispatch }, payload) {
    dispatch('PurchaseOrders/loadPurchaseOrder', payload, { root: true })
  },
  async deleteShipment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`/purchase-orders/${payload.purchase_order}/supplier-shipments/${payload.supplier_shipment.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_RECORD', payload.supplier_shipment)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.shippments', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async updateSupplierShipment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`/purchase-orders/${payload.purchase_order_id}/supplier-shipments/${payload.supplier_shipment_id}`, payload.data)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.shippments', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.shippments', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteShipmentDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`/supplier-shipments/${payload.supplier_shipment_id}/details/${payload.detail_id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_DETAIL', payload.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.details', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setShipmentsDetails ({ commit }, payload) {
    commit('SET_DETAILS', payload)
  },
  resetShipmentsDetails ({ commit }) {
    commit('SET_DETAILS', [])
  }
}

const getters = {
  supplierShippments: state => state.supplierShippments,
  isModalVisible: state => state.isModalVisible,
  details: state => state.details
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
